import React from 'react'
import PropTypes from 'prop-types'
import { getStatusStyle } from '../helpers'
import TintedPill from './TintedPill'

function PlanStatusBadge ({ status, statusStyleOverrides }) {
  if (!status) return null
  const style = getStatusStyle(status, statusStyleOverrides)
  return (
    <TintedPill color={style.color}>
      <span className='font-size-xs'>{status}</span>
    </TintedPill>
  )
}

PlanStatusBadge.propTypes = {
  status: PropTypes.string,
  statusStyleOverrides: PropTypes.object
}

export default PlanStatusBadge
